import React, { useEffect, useRef, useState } from 'react';
import { Play } from 'lucide-react';
import { contentShowcase } from '../../data/mock';

const ContentShowcase = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="portfolio"
      ref={sectionRef}
      className="relative py-24 md:py-32 bg-[#121212]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div
          className={`text-center mb-16 transition-all duration-1000 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <p className="text-[#D4AF37] text-xs tracking-[0.4em] mb-4">PORTFOLIO</p>
          <h2 className="font-playfair text-3xl md:text-4xl text-white">
            Featured <span className="italic text-[#D4AF37]">Content</span>
          </h2>
        </div>

        {/* Content Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {contentShowcase.map((item, index) => (
            <div
              key={item.id}
              className={`group relative overflow-hidden cursor-pointer transition-all duration-1000 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              {/* Image */}
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-[1.5s] ease-out group-hover:scale-110"
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-[#0A0A0A]/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                  <div className="w-16 h-16 rounded-full border-2 border-[#D4AF37] flex items-center justify-center transform scale-0 group-hover:scale-100 transition-transform duration-500">
                    <Play className="text-[#D4AF37] ml-1" size={24} />
                  </div>
                </div>

                {/* Gold Corner Accent */}
                <div className="absolute top-0 left-0 w-12 h-12 border-t-2 border-l-2 border-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 right-0 w-12 h-12 border-b-2 border-r-2 border-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>

              {/* Content Info */}
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-[#0A0A0A] to-transparent">
                <h3 className="text-white text-lg font-light mb-2 group-hover:text-[#D4AF37] transition-colors duration-300">
                  {item.title}
                </h3>
                <div className="flex gap-6 text-[#A1A1AA] text-sm">
                  <span>{item.views} views</span>
                  <span>{item.engagement} engagement</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContentShowcase;
